// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__UoYOU","lastUpdated":"TermsOfService_lastUpdated__2MJHw"};